import { Directionality, DIR_DOCUMENT } from '@angular/cdk/bidi';
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';

import { Customer } from '../customer.model';
import { MandoobService } from '../mandoobs/mandoob.service';
import { OptionService } from '../option.service';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'app-Customers',
  templateUrl: './Customers.component.html',
  styleUrls: ['./Customers.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("editModal"),
    contentRef2: new ViewChild("ModalConfirmReset"),
    contentRef3: new ViewChild("ModalConfirmAssignAsMandoob"),
    contentRef4: new ViewChild("ModalNewPassword"),
    contentRef5: new ViewChild("ModalConfirmLogoutFromAllDevices")
  },
})
export class CustomersComponent implements OnInit {

  customers: Customer[] = [];
  customersFilter: Customer[] = [];
  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<Customer>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  public contentRef4!: TemplateRef<any>;
  public contentRef5!: TemplateRef<any>;
  category: Customer = {} as Customer;
  customersStatus: { id: number, name: string }[] = [];
  userCategory: { id: number, name: string }[] = [];
  mandoobs: Customer[] = [];
  selectedStatus: number = 1;
  selectedMandoob: string = '';
  userId: string = "";
  userfullName: string = "";
  userPhone: string = "";
  pageSize = 100;

  editName!: string;
  editAddress!: string;
  editEmail!: string;
  editMobile!: string;

  newPassword = "";
  adminNewPassword = "";
  adminConfirmPassword = "";

  constructor(private service: OptionService,
    private userService: UsersService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private mandoobService: MandoobService) {

  }

  ngOnInit() {
    this.customersStatus = [{ id: 1, name: "active" },
    { id: 0, name: "notActive" }];

    this.displayedColumns = ['editInfo', 'name', 'mobile', 'email', "userCategoryId", "mandoobId",
      "options"];

    this.selectedStatus = 1;
    this.pageSize = this.globle.pageSize;
    this.getUserCategory();
    this.getCustomers();
    this.getManddobs();

  }

  getCustomers() {
    this.spinnerOverlay = true;
    let userId = this.localStorage.retrieve("userInfo").userId
    this.service.getAllCustomers(userId).subscribe(data => {
      this.customers = data;
      this.applyCustomersFilter();
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  getUserCategory() {
    this.service.getUserCategory().subscribe(data => {
      this.userCategory = data;
    }, error => {
      console.log(error)
    })
  }

  getManddobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
    }, error => {
      console.log(error)
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onDelete(id: string) {
    this.userId = id;
    this.openDialog();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogConfirmReset(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '420px',
    });
  }

  openDialogConfirmAssignAsMandoob(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '400px',
    });
  }

  openDialogEdit(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '300px',
    });
  }

  openDialogNewPassword(): void {
    const dialogRef = this.dialog.open(this.contentRef4, {
      width: '400px',
    });
  }

  openDialogConfirmLogoutFromAllDevices(): void {
    const dialogRef = this.dialog.open(this.contentRef5, {
      width: '400px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  back() {

  }

  selectChange() {
    this.applyCustomersFilter();
  }

  onSelectMandoob() {
    this.applyCustomersFilter();
  }

  applyCustomersFilter() {
    this.customersFilter = this.customers.filter(x => {
      if (x.approved != this.selectedStatus) {
        return false;
      }
      if (!this.selectedMandoob) {
        return true;
      }
      if (this.selectedMandoob === '0') {
        return !x.mandoobId;
      }
      return x.mandoobId == this.selectedMandoob;
    });

    this.dataSource = new MatTableDataSource(this.customersFilter);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  update(userData: any) {

    console.log(userData)
    this.spinnerOverlay = true;
    this.service.updateUserCategory(userData.id, userData.userCategoryId, userData.mandoobId).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  approve(userData: any) {
    this.spinnerOverlay = true;
    this.service.approvedUser(userData.id, userData.userCategoryId, userData.mandoobId).subscribe(data => {
      this.openSnackBar(this.translateService.instant("approvedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCustomers();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.openSnackBar(error.error.message, 'snackBarError');
      })
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.deleteUser(this.userId).subscribe(data => {
      this.openSnackBar(this.translateService.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  onDeactivate(id: string, _status: number) {

    var obj = {
      userId: id,
      status: _status == 1 ? 0 : 1
    }

    this.spinnerOverlay = true;

    this.service.ChangeUserStatus(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })

  }

  edit(data: any) {
    this.editName = data['fullName'];
    this.editEmail = data['email'];
    this.editMobile = data['phoneNumber'];
    this.editAddress = data['address'];
    this.userId = data['id'];

    this.openDialogEdit();
  }

  updateUserInfo() {
    this.spinnerOverlay = true;
    var obj = {
      id: this.userId,
      fullName: this.editName,
      address: this.editAddress,
      email: this.editEmail,
      phoneNumber: this.editMobile
    }

    this.userService.Update(obj).subscribe(data => {
      this.dialog.closeAll();
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCustomers();

    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  resetPassword(data: any) {
    this.userPhone = data.userName;
    this.userfullName = data.fullName;
    this.adminNewPassword = "";
    this.adminConfirmPassword = "";

    this.openDialogConfirmReset();
  }

  confirmReset() {
    if (!this.adminNewPassword || this.adminNewPassword.trim().length < 4) {
      this.openSnackBar(this.translateService.instant("passwordMinLength"), 'snackBarError');
      return;
    }

    if (this.adminNewPassword !== this.adminConfirmPassword) {
      this.openSnackBar(this.translateService.instant("confirmPasswordMessageError"), 'snackBarError');
      return;
    }

    var obj = {
      emailOrPhone: this.userPhone,
      newPassword: this.adminNewPassword.trim()
    }
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.service.resetUserPassword(obj).subscribe(data => {
      this.newPassword = data["newPassword"];
      this.openDialogNewPassword();
      this.openSnackBar("تم اعادة تعيين كلمة السر بنجاح", 'snackBarSuccess');

      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  assignAssMandoob(data: any) {
    this.userId = data.id;
    this.userPhone = data.userName;
    this.userfullName = data.fullName;
    this.openDialogConfirmAssignAsMandoob();
  }

  confirmAssignMandoob() {
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.service.changeCustomerToMandoob(this.userId).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');

      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
        this.openSnackBar(error.error.message, 'snackBarError');
      })
  }

  logoutFromAllDevices(data: any) {
    this.userId = data.id;
    this.userPhone = data.userName;
    this.userfullName = data.fullName;
    this.openDialogConfirmLogoutFromAllDevices();
  }

  confirmLogoutFromAllDevices() {
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.service.logoutFromAllDevices(this.userId).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    }, error => {
      this.spinnerOverlay = false;
      console.log(error);
      this.openSnackBar(error.error.message, 'snackBarError');
    });
  }
}
